
<div v-if="isVisible">
  <object-model-entry-form-field
    v-if="isEditableProperty"
    :object-model="contentElement.objectModel"
    :objectModelEntry="entry"
    :label-title="contentElement.label_title"
    :is-detail-view-edit="true"
    :format-as-percentage="formatAsPercentage"
    :property-client-id="contentElement.property.client_id"
    @queue-upload-for-deletion="$emit('queue-upload-for-deletion', $event)"
  ></object-model-entry-form-field>

  <template v-else>
    <help-tooltip v-if="shouldShowToolTip"
      :text="toolTipText"
    ></help-tooltip>

    <detail-view-content-element-base
      :key="contentElement.id"
      :is-in-edit-mode="true"
      :content-element="contentElement"
      :entry="entry"
    >
    </detail-view-content-element-base>
  </template>
</div>
